import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingButton from './BookingButton';

const {FiSearch,FiFileText,FiPlay,FiTrendingUp}=FiIcons;

const HowItWorksSection=()=> {
const steps=[ 
{icon: FiSearch,number: "01",title: "Comprehensive Developmental Assessment",description: "We evaluate communication,feeding,executive function foundations,and any signs of neurodevelopmental differences. No stone unturned.",color: "primary"},
{icon: FiFileText,number: "02",title: "Your Child's Personalized Growth Blueprint",description: "Get a customized therapy plan targeting your child's unique developmental profile and your family's goals. This is precision early intervention designed for their specific brain and needs.",color: "green"},
{icon: FiPlay,number: "03",title: "Skill-Building Play Sessions",description: "Weekly 1-on-1 therapy that feels like play but is designed to build critical neural pathways. Parent coaching included so you can support development at home.",color: "accent-gold"},
{icon: FiTrendingUp,number: "04",title: "Integrate & Thrive",description: "We empower you to use these strategies in daily life—at mealtimes,during play,and on the go—turning your home into a learning lab and ensuring lasting progress.",color: "accent-magenta"} 
];

const getColorClasses=(color)=> {
const colorMap={
primary: "bg-primary-100 text-primary-600 border-primary-200",
green: "bg-green-100 text-green-600 border-green-200",
"accent-gold": "bg-yellow-100 text-yellow-600 border-yellow-200",
"accent-magenta": "bg-pink-100 text-pink-600 border-pink-200"
};
return colorMap[color] || colorMap.primary;
};

const getNumberBg=(color)=> {
const colorMap={
primary: "bg-primary-600",
green: "bg-green-600",
"accent-gold": "bg-yellow-600",
"accent-magenta": "bg-pink-600"
};
return colorMap[color] || colorMap.primary;
};

return ( 
<section id="how-it-works" className="py-20 bg-white"> 
<div className="max-w-6xl mx-auto px-6 lg:px-8"> 
<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="text-center mb-12" > 
<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 font-serif"> From Worried Parent to <span className="text-primary-600">Confident Advocate</span> in 4 Steps </h2> 
</motion.div> 

<div className="grid lg:grid-cols-2 gap-8 items-start"> 
{steps.map((step,index)=> ( 
<motion.div key={index} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8,delay: index * 0.2}} className="relative" > 
<div className="flex items-start space-x-4"> 
{/* Step Number */} 
<div className={`${getNumberBg(step.color)} text-white rounded-full w-12 h-12 flex items-center justify-center font-bold flex-shrink-0`}> {step.number} </div> 
<div className="flex-1"> 
<div className="flex items-center mb-3"> 
<div className={`w-10 h-10 ${getColorClasses(step.color)} rounded-lg flex items-center justify-center mr-3 border-2`}> 
<SafeIcon icon={step.icon} className="h-5 w-5" /> 
</div> 
<h3 className="text-lg font-bold text-gray-900 font-serif"> {step.title} </h3> 
</div> 
<p className="text-gray-600 leading-relaxed text-sm"> {step.description} </p> 
</div> 
</div> 
{/* Connection Line */} 
{index < steps.length - 1 && ( 
<div className="hidden lg:block absolute left-6 top-16 w-0.5 h-16 bg-gray-200"></div> 
)} 
</motion.div> 
))} 
</div> 

<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.8}} className="text-center mt-12" > 
<div className="flex flex-col sm:flex-row gap-4 justify-center"> 
<BookingButton text="Start Your Journey" /> 
<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} href="https://www.wethebillions.com/quiz" className="btn-secondary" > 
Learn About Your Child 
</motion.a> 
</div> 
</motion.div> 
</div> 
</section> 
);
};

export default HowItWorksSection;